import React from "react";
import { ArrowRight } from "@phosphor-icons/react";

// SEGURIDAD: Extraemos con valores de respaldo para evitar "undefined"
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "522282425769";
const WHATSAPP_MSG = process.env.REACT_APP_WHATSAPP_MSG_HERO || "Hola, me gustaría cotizar un servicio para mi equipo.";

const Hero = () => {
    // Generamos el link de forma segura
    const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        WHATSAPP_MSG
    )}`;

    return (
        <section
            id="inicio"
            className="relative h-screen flex items-center justify-center bg-cover bg-center overflow-hidden"
            style={{ backgroundImage: "url('/img/BanerCTEX.jpeg')" }}
        >
            <div className="absolute inset-0 bg-black/65"></div>

            <div className="relative z-10 container mx-auto px-6 text-center max-w-4xl">
                <h1
                    data-aos="fade-up"
                    className="text-5xl md:text-6xl lg:text-7xl font-black tracking-normal leading-tight mb-8"
                >
                    <span className="text-white block mb-2 drop-shadow-md">Expertos en </span>
                    <span className="text-ctex-orange drop-shadow-xl">
                        mantenimiento integral, <br />
                        <span className="inline-block mt-2">Equipo y Refacciones</span>
                    </span>
                </h1>

                <p
                    data-aos="fade-up"
                    data-aos-delay="100"
                    className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-12 font-medium max-w-2xl mx-auto drop-shadow-lg leading-relaxed"
                >
                    Soluciones técnicas especializadas para mantener <span className="font-bold text-white border-b-2 border-ctex-orange/40">la operación continua</span> de equipos e instalaciones.
                </p>

                <div data-aos="zoom-in" data-aos-delay="200" className="flex flex-col md:flex-row gap-4 justify-center">
                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer" // SEGURIDAD: Protege la sesión del usuario
                        className="inline-flex items-center justify-center gap-3 bg-ctex-orange hover:bg-orange-600 text-white font-bold py-5 px-10 rounded-full text-xl transition-all shadow-2xl transform hover:scale-105"
                    >
                        Solicitar servicio
                        <ArrowRight size={24} weight="bold" />
                    </a>
                </div>
            </div>

            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
                <div className="w-1 h-12 bg-gradient-to-b from-ctex-orange to-transparent rounded-full"></div>
            </div>
        </section>
    );
};

export default Hero;
